import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InsuranceService } from '../../../../../services/insurance.service';

@Component({
  selector: 'app-insurance-quotes',
  templateUrl: './insurance-quotes.component.html',
  styleUrls: ['./insurance-quotes.component.scss'],
})
export class InsuranceQuotesComponent implements OnInit {
  public quoteid: string;
  public quote: any = {};
  public loading: boolean = false;
  public selectedInsurer: null;
  public showPopOver: boolean = false;
  public lockScroll: boolean = false;
  public pageYOffset = 0;
  public lastPageYOffset = 0;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public insuranceService: InsuranceService,
  ) {}

  ngOnInit() {
    this.quoteid = this.route.snapshot.paramMap.get('quoteid');
    this.loading = true;
    this.insuranceService.getInsuranceQuote(this.quoteid).subscribe(
      (quote) => {
        this.quote = quote;
        this.quote.quoteItem.sort((a, b) => {
          if (a.premiumAmount < b.premiumAmount) {
            return -1;
          } else if (a.premiumAmount > b.premiumAmount) {
            return 1;
          } else {
            return 0;
          }
        });
        this.loading = false;
      },
      (err) => {
        this.quote = {
          id: 1,
          quoteID: '953b40a5-065b-4424-814a-d2cc31ab6e56',
          name: 'Michael',
          surname: 'Kumm',
          email: 'michael@hubtiger.com',
          phoneNumber: '+27824145627',
          bikeShop: 'Hubtiger Virtual Workshop',
          bikeManufacturer: 'Pyga',
          bikeModel: 'Stage GX Eagle',
          bikeColor: '',
          bikeYear: 2020,
          bikeSerialNumber: '',
          quotedAmount: 65000.0,
          quoteItem: [
            {
              id: 2,
              providerID: 1,
              provider: 'Pineapple',
              overview:
                "It's Painless. It's Fair. <span style=\"font-weight: 800;\">It's Pineapple.</span><br>Cover that suits your lifestyle",
              disclaimer:
                '<span>Pineapple is an authorised Financial Services Provider number 48650.</span>',
              information:
                '<p class="intercom-align-left" style="color: rgb(86, 88, 103); font-family: proxima-nova, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; font-size: 17px;"><b>Examples of such exclusions include but are not limited to:</b></p><ul style="box-sizing: inherit; padding-left: 16px; margin-bottom: 27px; color: rgb(86, 88, 103); font-family: proxima-nova, &quot;Helvetica Neue&quot;, Helvetica, Arial, sans-serif; font-size: 17px;"><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">depreciation, or gradual causes such as wear and tear, deterioration, rust, rising damp and mildew, corrosion or decay</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">damage caused by moths, vermin or insects</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">flaws or defects, whether present when the item was new or discovered afterwards</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">fluctuations in atmospheric or climatic conditions, or the effects of light&nbsp;</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">any process of cleaning, dyeing or renovating</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">the bursting, rusting, corrosion or deterioration of any firearm</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">defective design, specification, construction or material</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">lack of maintenance or upgrading</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">any type of virus or malware (harmful software such as viruses or Trojans)</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">chipping, scratching, denting or breakage of porcelain or similar articles of a fragile nature</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">loss or damage while items are mailed or couriered unless specifically agreed by us in writing</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">accidental damage to sporting equipment, hobby equipment, musical instrument while being used (<i style="box-sizing: inherit;">Exceptions do apply under certain conditions for the likes of Bicycles, drones and air-sports equipment)</i></li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">any damage which is covered under a guarantee or warranty</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">electrical, electronic or mechanical breakdown, unless accompanied or caused by other insured damage</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">a cleaning, repairing or restoration process</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">cracking or scratching (unless caused by theft, attempted theft, fire or explosion) of glassware, glass or other brittle articles other than jewellery, cameras, fixed glass, TV sets or digital screens.</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">the cost of reproduction or repair of data or software</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">loss or damage caused by domestic animals</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 5px;">loss or damage caused by wild animals or reptiles</li><li style="box-sizing: inherit; margin-left: 15px; margin-bottom: 0px;">theft of the bicycle / pedal-cyclefrom an unattended vehicle unless the vehicle is locked, or the bicycle / pedal-cycle is locked to the vehicle; andthere are clear signs of forced entry or removal</li></ul>',
              estimatedTime: '±5 Minutes - 2 Steps',
              providerLogo:
                'https://hubtiger.blob.core.windows.net/insurance/pinappleheader_1024.png',
              primaryColorCode: '#68c9d0',
              secondaryColorCode: '#ffd400',
              premiumAmount: 325.0,
            },
            {
              id: 3,
              providerID: 2,
              provider: 'JaSure',
              overview:
                '<span style="font-weight: 800;">On-demand protection for your favourite things</span><br>Choose what you want to insure, when you want to insure it.',
              disclaimer:
                '<span>JaSure is a juristic representative of Santam Limited an authorised Financial Services Provider number 3416.</span>',
              information:
                'It’s simple! The JaSure mobile application (“App”) gives you the flexibility to switch on cover for your asset when you need it and switch off cover when you don’t. You can add assets in the JaSure App and manage cover for each asset based on your cover needs. The control is in your hands.',
              estimatedTime: '±20 Minutes - 5 Steps',
              providerLogo:
                'https://hubtiger.blob.core.windows.net/insurance/jasure.png',
              primaryColorCode: '#ff3661',
              secondaryColorCode: '#0e225b',
              premiumAmount: 287.0,
            },
            {
              id: 4,
              providerID: 3,
              provider: 'Naked',
              overview:
                '<span style="font-weight:800">The new way to insure your stuff!</span><br>Instant, honest insurance at game-changing prices.',
              disclaimer:
                '<span>Naked Financial Technology Pty Ltd is an authorised Financial Services Provider number 48822.</span>',
              information:
                '<b>1.&nbsp;Get a final quote in 90 seconds</b><div><i>Get your final price without a call centre.</i></div><div><br></div><div><b>2.&nbsp;Customize your quote</b></div><div><i>Choose your insured value, set your excess and start date.</i></div><div><br></div><div><b>3.&nbsp;Get covered instantly</b></div><div><i>Like the low price? Add your card details to activate your cover instantly (or choose a future start date).</i></div><div><br></div><div><b>4.&nbsp;Let’s help you cancel your existing cover</b></div><p color="#FFFFFF" font-size="15" class="typography__Paragraph-uhljb2-2 klOSlE" style="line-height: 1.67; margin-top: 10px;"><i>We know it\'s a hassle, so let us help you cancel your current insurance policy.</i></p><div><br></div><div style="color: rgb(70, 210, 129)!important; font-size:20px; font-weight: 800">Complete coverage</div><div><b><br></b></div><div><b>Theft</b><p color="#929292" class="typography__Paragraph-uhljb2-2 cCCRXd" style="line-height: 1.5;">When the bad guys steal or damage your stuff, we\'ve got your back.</p><p color="#929292" class="typography__Paragraph-uhljb2-2 cCCRXd" style="line-height: 1.5;"><br></p><b>Accidental damage</b><p color="#929292" class="typography__Paragraph-uhljb2-2 cCCRXd" style="line-height: 1.5;">When accidental oopsies damage your stuff and it\'s toast, you\'re covered.</p><p color="#929292" class="typography__Paragraph-uhljb2-2 cCCRXd" style="line-height: 1.5;"><br></p><b>Loss</b><p color="#929292" class="typography__Paragraph-uhljb2-2 cCCRXd" style="line-height: 1.5;">Cover for when you forget your phone on the plane and despite your best efforts, you don\'t get it back.</p></div>',
              estimatedTime: '±8 Minutes - 3 Steps',
              providerLogo:
                'https://hubtiger.blob.core.windows.net/insurance/naked.png',
              primaryColorCode: 'rgb(35, 31, 32)',
              secondaryColorCode: 'rgb(70, 210, 129)',
              premiumAmount: 250.0,
            },
          ],
        };
        this.quote.quoteItem.sort((a, b) => {
          if (a.premiumAmount < b.premiumAmount) {
            return -1;
          } else if (a.premiumAmount > b.premiumAmount) {
            return 1;
          } else {
            return 0;
          }
        });
        this.loading = false;
      },
    );
  }

  ngAfterViewInit(): void {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    this.pageYOffset = window.pageYOffset;
  }

  selectInsurer(id) {
    this.selectedInsurer = id;

    this.lastPageYOffset = this.pageYOffset;
    setTimeout(() => {
      this.showPopOver = true;
      setTimeout(() => {
        this.lockScroll = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 1000);
    }, 1000);
  }

  getInformation() {
    if (this.selectedInsurer) {
      return this.quote.quoteItem
        .filter((x) => {
          return x.providerID === this.selectedInsurer;
        })
        .pop().information;
    } else {
      return '';
    }
  }

  getDisclaimer() {
    if (this.selectedInsurer) {
      return this.quote.quoteItem
        .filter((x) => {
          return x.providerID === this.selectedInsurer;
        })
        .pop().disclaimer;
    } else {
      return '';
    }
  }

  getProviderLogo() {
    if (this.selectedInsurer) {
      return this.quote.quoteItem
        .filter((x) => {
          return x.providerID === this.selectedInsurer;
        })
        .pop().providerLogo;
    } else {
      return '';
    }
  }

  getProviderPrimaryColor() {
    if (this.selectedInsurer) {
      return (
        this.quote.quoteItem
          .filter((x) => {
            return x.providerID === this.selectedInsurer;
          })
          .pop().primaryColorCode + '!important'
      );
    } else {
      return '#314255!important';
    }
  }

  getQuote() {
    if (this.selectedInsurer === 1) {
      window.open(
        'https://www.pineapple.co.za/?shortlink=getQuote&pid=GetQuoteWebsiteButton',
        '_blank',
      );
    } else if (this.selectedInsurer === 2) {
      window.open('https://quotes.jasure.com/', '_blank');
    } else if (this.selectedInsurer === 3) {
      window.open('https://www.naked.insure/quote', '_blank');
    }
  }

  closePopOver() {
    this.lockScroll = false;
    window.scrollTo({ top: this.lastPageYOffset, left: 0, behavior: 'auto' });
    setTimeout(() => {
      this.showPopOver = false;
    }, 250);
  }
}
